import React, { useContext } from 'react';
import axios from 'axios';
// import { useCookie } from "../hooks";
// import { StateContext } from '../components/context/ManageStates';
// import Cookies from 'universal-cookie';
import Cookies from 'universal-cookie';
const Apis = () => {
  // const { getCookie } = useCookie()
  var cookies = new Cookies();

  // var cookies = new Cookies();

  // const { authStatus, authToken } = useContext(StateContext);

  // axios.defaults.baseURL = "https://admin.apnashopee.com/";
  axios.defaults.baseURL = "https://api.nurexify.com/api/elastic/";
  // axios.defaults.baseURL = "https://admin.shopersbay.com/";
  // axios.defaults.baseURL = "https://dev.shopersbay.com/";
  // let api =axios.create({
  //   baseURL : "https://dev.shopersbay.com/"
  // })
  // axios.defaults.baseURL = "https://dev.shopersbay.com";
  // axios.defaults.headers.common['authentication'] = localStorage.getItem("qwerty");
  // axios.defaults.baseURL = "https://demo.shopersbay.com/";
  // axios.defaults.headers.common['authentication'] = localStorage.getItem("qwerty"); // jhaluck

  // axios.defaults.headers.common['authentication'] = "367227bfef155e4eaaf783170428c30f"; // vendor my localflorist
  // axios.defaults.headers.common['authentication'] = "b018e99f3743d7ab661688d6f334ee1e"; //multivebdor 
  axios.defaults.headers.common['authentication'] = "6bf3400de25033b89ed0d0204904484d"; //nurexify
  // axios.defaults.headers.common['authentication'] = "CWDpLQ1311012WPdssW52769d731"; //redtelugu
  // if (authStatus) {
  //   var config = {
  //     headers: { authorization: authToken }
  //   };
  // }
  const getMasterDataService = async () => {
    const response = await axios.get("getBlogList?lt=500")
    // const response = await axios.get("asapi/getMasterData")
    return response;
  };
  const gvt = async (input_data) => {
    const response = await axios.post("asapi/gvt", input_data,);
    return response;
  };
  const getNewsDatalist = async () => {
    const response = await axios.get("getHomePage");
    return response;
  }
  const getNavigationlist = async () => {
    const response = await axios.get("getNavigationList");
    return response;
  }

  const getSubcategoryPostdatalist = async (params) => {
    const response = await axios.get("getBlogList", {
      params: {
        lt:500,
        ...params
      }
    });
    return response;
  };

  const getBlogdetail = async (slug) => {
    const response = await axios.get(`getBlogDetail/${slug}`)
    return response
  }

const getRelatedBlogs = async (params) => {
    const response = await axios.get(`getRelatedBlogList`, {
      params : {
        lt:500,
        ...params
      }
    })
    return response
  }

  const getdetaillist = async (input_data) => {
    const response = await axios.post("asapi/getPostsDetail", input_data);
    return response;
  }

  const getRelatedPostslist = async (input_data) => {
    const response = await axios.post("asapi/getRelatedPosts", input_data);
    return response;
  }
  return {
    getNewsDatalist,
    getNavigationlist,
    gvt: gvt,
    getSubcategoryPostdatalist: getSubcategoryPostdatalist,
    getdetaillist: getdetaillist,
    getRelatedPostslist: getRelatedPostslist,
    getMasterDataService: getMasterDataService,
    getBlogdetail,
    getRelatedBlogs
  };
};
export default Apis;